import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import { ClearFactoryFilesReducer, GetFactoryFilesReducer } from './reducers';
import { addExtraReducer } from '../../utils/addExtraReducer';
import { GetFactoryFiles } from './thunks';

export const slice = createSlice({
  name: 'factoryFiles',
  initialState,
  reducers: {
    ClearFactoryFiles: ClearFactoryFilesReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetFactoryFiles, GetFactoryFilesReducer);
  },
});

export default slice.reducer;
